// Demo preset data. Each object must satisfy formSchema.
// Three examples covering different student profiles for Gr. 9–12.

const emptyCourse = (n) => ({
  [`course${n}Title`]: '', [`course${n}Code`]: '', [`course${n}Teacher`]: '',
  [`course${n}ESLELD`]: '', [`course${n}IEP`]: '', [`course${n}French`]: '', [`course${n}SHSM`]: '',
  [`course${n}FirstPercentageMark`]: '', [`course${n}FirstMedian`]: '', [`course${n}FirstCreditEarned`]: '',
  [`course${n}FirstResponsibility`]: '', [`course${n}FirstOrganization`]: '', [`course${n}FirstIndependentWork`]: '',
  [`course${n}FirstCollaboration`]: '', [`course${n}FirstInitiative`]: '', [`course${n}FirstSelfRegulation`]: '',
  [`course${n}FirstClassesMissed`]: '', [`course${n}FirstTotalClasses`]: '', [`course${n}FirstTimesLate`]: '',
  [`course${n}FinalPercentageMark`]: '', [`course${n}FinalMedian`]: '', [`course${n}FinalCreditEarned`]: '',
  [`course${n}FinalResponsibility`]: '', [`course${n}FinalOrganization`]: '', [`course${n}FinalIndependentWork`]: '',
  [`course${n}FinalCollaboration`]: '', [`course${n}FinalInitiative`]: '', [`course${n}FinalSelfRegulation`]: '',
  [`course${n}FinalClassesMissed`]: '', [`course${n}FinalTotalClasses`]: '', [`course${n}FinalTimesLate`]: '',
  [`course${n}Comments`]: '',
});

const emptyCredits = {
  compulsoryCreditsEarnedThisReport: '', compulsoryCreditsEarnedToDate: '',
  englishEarnedThisReport: '', englishEarnedToDate: '',
  frenchEarnedThisReport: '', frenchEarnedToDate: '',
  mathematicsEarnedThisReport: '', mathematicsEarnedToDate: '',
  scienceEarnedThisReport: '', scienceEarnedToDate: '',
  canadianHistoryEarnedThisReport: '', canadianHistoryEarnedToDate: '',
  canadianGeographyEarnedThisReport: '', canadianGeographyEarnedToDate: '',
  theArtsEarnedThisReport: '', theArtsEarnedToDate: '',
  healthPhysicalEducationEarnedThisReport: '', healthPhysicalEducationEarnedToDate: '',
  civicsEarnedThisReport: '', civicsEarnedToDate: '',
  careerEarnedThisReport: '', careerEarnedToDate: '',
  group1EarnedThisReport: '', group1EarnedToDate: '',
  group2EarnedThisReport: '', group2EarnedToDate: '',
  group3EarnedThisReport: '', group3EarnedToDate: '',
  optionalCreditsEarnedThisReport: '', optionalCreditsEarnedToDate: '',
  totalCreditsRequiredEarnedThisReport: '', totalCreditsRequiredEarnedToDate: '',
  communityInvolvementEarnedThisReport: '', communityInvolvementEarnedToDate: '',
  onlineLearningRequirementEarnedThisReport: '', onlineLearningRequirementEarnedToDate: '',
  specialistHighSkillsMajorName: '', specialistHighSkillsMajorTotalRequired: '',
  specialistHighSkillsMajorEarnedThisReport: '', specialistHighSkillsMajorEarnedToDate: '',
  oSSLiteracyRequirementCompleted: '', schoolUse: '',
  principalSignatureDate: '',
};

export const PRESETS = [
  {
    label: 'Example: High Achiever',
    data: {
      semester: '1', reportingPeriod: 'First', date: '2025-02-14',
      studentName: 'Priya Sharma', oen: '123456789', grade: '11', homeroom: '205',
      principal: 'Ms. Paulette Okafor', studentAddress: '12 Maple St, Toronto ON M4B 1B3',
      schoolCouncilChair: 'David Chen',
      schoolName: 'Northview Secondary School', schoolTelephone: '416-555-0100',
      schoolAddress: '500 Northview Ave, Toronto ON M4B 2C1', schoolFax: '416-555-0101',
      boardName: 'Toronto District School Board', boardEmailWebsite: 'tdsb.on.ca', boardAddress: '5050 Yonge St, Toronto ON M2N 5N8',
      course1Title: 'English', course1Code: 'ENG3U', course1Teacher: 'Mr. Thompson',
      course1ESLELD: '', course1IEP: '', course1French: '', course1SHSM: '',
      course1FirstPercentageMark: '88', course1FirstMedian: '72', course1FirstCreditEarned: 'yes',
      course1FirstResponsibility: 'E', course1FirstOrganization: 'E', course1FirstIndependentWork: 'E',
      course1FirstCollaboration: 'G', course1FirstInitiative: 'E', course1FirstSelfRegulation: 'E',
      course1FirstClassesMissed: '2', course1FirstTotalClasses: '90', course1FirstTimesLate: '0',
      course1FinalPercentageMark: '91', course1FinalMedian: '74', course1FinalCreditEarned: 'yes',
      course1FinalResponsibility: 'E', course1FinalOrganization: 'E', course1FinalIndependentWork: 'E',
      course1FinalCollaboration: 'E', course1FinalInitiative: 'E', course1FinalSelfRegulation: 'E',
      course1FinalClassesMissed: '1', course1FinalTotalClasses: '90', course1FinalTimesLate: '0',
      course1Comments: 'Priya consistently demonstrates a strong command of written and oral communication. She contributes meaningfully to class discussions and produces work of exceptional quality.',
      course2Title: 'Mathematics', course2Code: 'MCF3M', course2Teacher: 'Ms. Reyes',
      course2ESLELD: '', course2IEP: '', course2French: '', course2SHSM: '',
      course2FirstPercentageMark: '85', course2FirstMedian: '68', course2FirstCreditEarned: 'yes',
      course2FirstResponsibility: 'E', course2FirstOrganization: 'G', course2FirstIndependentWork: 'E',
      course2FirstCollaboration: 'G', course2FirstInitiative: 'G', course2FirstSelfRegulation: 'E',
      course2FirstClassesMissed: '2', course2FirstTotalClasses: '90', course2FirstTimesLate: '1',
      course2FinalPercentageMark: '89', course2FinalMedian: '70', course2FinalCreditEarned: 'yes',
      course2FinalResponsibility: 'E', course2FinalOrganization: 'E', course2FinalIndependentWork: 'E',
      course2FinalCollaboration: 'E', course2FinalInitiative: 'G', course2FinalSelfRegulation: 'E',
      course2FinalClassesMissed: '1', course2FinalTotalClasses: '90', course2FinalTimesLate: '0',
      course2Comments: 'Priya excels in problem-solving and demonstrates strong conceptual understanding. She is an asset to collaborative problem-solving tasks.',
      ...emptyCourse(3), ...emptyCourse(4),
      ...emptyCourse(5), ...emptyCourse(6), ...emptyCourse(7), ...emptyCourse(8), ...emptyCourse(9),
      ...emptyCredits,
      compulsoryCreditsEarnedThisReport: '2', compulsoryCreditsEarnedToDate: '14',
      englishEarnedThisReport: '1', englishEarnedToDate: '2',
      mathematicsEarnedThisReport: '1', mathematicsEarnedToDate: '2',
      totalCreditsRequiredEarnedThisReport: '2', totalCreditsRequiredEarnedToDate: '14',
      _completedFields: [],
    },
  },
  {
    label: 'Example: IEP Student',
    data: {
      semester: '1', reportingPeriod: 'First', date: '2025-02-14',
      studentName: 'Marcus Johnson', oen: '987654321', grade: '10', homeroom: '112',
      principal: 'Mr. Singh', studentAddress: '45 Oak Ave, Mississauga ON L5B 2T6',
      schoolCouncilChair: 'Maria Rossi',
      schoolName: 'Lakeview Secondary School', schoolTelephone: '905-555-0200',
      schoolAddress: '200 Lakeview Blvd, Mississauga ON L5B 1A1', schoolFax: '905-555-0201',
      boardName: 'Peel District School Board', boardEmailWebsite: 'peelschools.org', boardAddress: '5650 Hurontario St, Mississauga ON L5R 1C6',
      course1Title: 'English', course1Code: 'ENG2P', course1Teacher: 'Ms. Williams',
      course1ESLELD: '', course1IEP: 'yes', course1French: '', course1SHSM: '',
      course1FirstPercentageMark: '71', course1FirstMedian: '65', course1FirstCreditEarned: 'yes',
      course1FirstResponsibility: 'G', course1FirstOrganization: 'S', course1FirstIndependentWork: 'G',
      course1FirstCollaboration: 'G', course1FirstInitiative: 'S', course1FirstSelfRegulation: 'G',
      course1FirstClassesMissed: '5', course1FirstTotalClasses: '90', course1FirstTimesLate: '2',
      course1FinalPercentageMark: '74', course1FinalMedian: '66', course1FinalCreditEarned: 'yes',
      course1FinalResponsibility: 'G', course1FinalOrganization: 'G', course1FinalIndependentWork: 'G',
      course1FinalCollaboration: 'G', course1FinalInitiative: 'G', course1FinalSelfRegulation: 'G',
      course1FinalClassesMissed: '3', course1FinalTotalClasses: '90', course1FinalTimesLate: '1',
      course1Comments: 'Marcus demonstrates growth in his reading and writing skills with the support of his IEP accommodations. He is encouraged to continue building confidence in oral presentations.',
      course2Title: 'Mathematics', course2Code: 'MFM2P', course2Teacher: 'Mr. Patel',
      course2ESLELD: '', course2IEP: 'yes', course2French: '', course2SHSM: '',
      course2FirstPercentageMark: '68', course2FirstMedian: '60', course2FirstCreditEarned: 'yes',
      course2FirstResponsibility: 'G', course2FirstOrganization: 'S', course2FirstIndependentWork: 'S',
      course2FirstCollaboration: 'G', course2FirstInitiative: 'S', course2FirstSelfRegulation: 'G',
      course2FirstClassesMissed: '5', course2FirstTotalClasses: '90', course2FirstTimesLate: '2',
      course2FinalPercentageMark: '72', course2FinalMedian: '62', course2FinalCreditEarned: 'yes',
      course2FinalResponsibility: 'G', course2FinalOrganization: 'G', course2FinalIndependentWork: 'S',
      course2FinalCollaboration: 'G', course2FinalInitiative: 'G', course2FinalSelfRegulation: 'G',
      course2FinalClassesMissed: '3', course2FinalTotalClasses: '90', course2FinalTimesLate: '1',
      course2Comments: 'Marcus shows improved understanding of foundational math concepts. With accommodations in place, he is better able to demonstrate his knowledge on assessments.',
      ...emptyCourse(3), ...emptyCourse(4),
      ...emptyCourse(5), ...emptyCourse(6), ...emptyCourse(7), ...emptyCourse(8), ...emptyCourse(9),
      ...emptyCredits,
      compulsoryCreditsEarnedThisReport: '2', compulsoryCreditsEarnedToDate: '8',
      englishEarnedThisReport: '1', englishEarnedToDate: '1',
      mathematicsEarnedThisReport: '1', mathematicsEarnedToDate: '1',
      totalCreditsRequiredEarnedThisReport: '2', totalCreditsRequiredEarnedToDate: '8',
      _completedFields: [],
    },
  },
  {
    label: 'Example: SHSM Student',
    data: {
      semester: '1', reportingPeriod: 'First', date: '2025-02-14',
      studentName: 'Fatima Al-Hassan', oen: '456789123', grade: '12', homeroom: '301',
      principal: 'Dr. Chen', studentAddress: '88 Wellington St, Ottawa ON K1A 0A9',
      schoolCouncilChair: 'Jacques Tremblay',
      schoolName: 'Capital Secondary School', schoolTelephone: '613-555-0300',
      schoolAddress: '100 Capital Dr, Ottawa ON K1A 1A1', schoolFax: '613-555-0301',
      boardName: 'Ottawa-Carleton District School Board', boardEmailWebsite: 'ocdsb.ca', boardAddress: '133 Greenbank Rd, Ottawa ON K2H 6L3',
      course1Title: 'Biology', course1Code: 'SBI4U', course1Teacher: 'Ms. Nguyen',
      course1ESLELD: '', course1IEP: '', course1French: '', course1SHSM: 'yes',
      course1FirstPercentageMark: '83', course1FirstMedian: '71', course1FirstCreditEarned: 'yes',
      course1FirstResponsibility: 'E', course1FirstOrganization: 'G', course1FirstIndependentWork: 'E',
      course1FirstCollaboration: 'G', course1FirstInitiative: 'G', course1FirstSelfRegulation: 'E',
      course1FirstClassesMissed: '1', course1FirstTotalClasses: '90', course1FirstTimesLate: '0',
      course1FinalPercentageMark: '86', course1FinalMedian: '73', course1FinalCreditEarned: 'yes',
      course1FinalResponsibility: 'E', course1FinalOrganization: 'E', course1FinalIndependentWork: 'E',
      course1FinalCollaboration: 'G', course1FinalInitiative: 'G', course1FinalSelfRegulation: 'E',
      course1FinalClassesMissed: '0', course1FinalTotalClasses: '90', course1FinalTimesLate: '0',
      course1Comments: 'Fatima demonstrates a deep interest in biological systems and applies scientific thinking effectively. Her lab work is precise and her written analysis is well-developed.',
      course2Title: 'Chemistry', course2Code: 'SCH4U', course2Teacher: 'Mr. Kowalski',
      course2ESLELD: '', course2IEP: '', course2French: '', course2SHSM: 'yes',
      course2FirstPercentageMark: '79', course2FirstMedian: '68', course2FirstCreditEarned: 'yes',
      course2FirstResponsibility: 'G', course2FirstOrganization: 'G', course2FirstIndependentWork: 'E',
      course2FirstCollaboration: 'G', course2FirstInitiative: 'G', course2FirstSelfRegulation: 'G',
      course2FirstClassesMissed: '2', course2FirstTotalClasses: '90', course2FirstTimesLate: '0',
      course2FinalPercentageMark: '82', course2FinalMedian: '70', course2FinalCreditEarned: 'yes',
      course2FinalResponsibility: 'E', course2FinalOrganization: 'G', course2FinalIndependentWork: 'E',
      course2FinalCollaboration: 'G', course2FinalInitiative: 'G', course2FinalSelfRegulation: 'G',
      course2FinalClassesMissed: '1', course2FinalTotalClasses: '90', course2FinalTimesLate: '0',
      course2Comments: 'Fatima consistently demonstrates strong analytical skills in chemistry. She is working towards her SHSM in Health Sciences.',
      ...emptyCourse(3), ...emptyCourse(4),
      ...emptyCourse(5), ...emptyCourse(6), ...emptyCourse(7), ...emptyCourse(8), ...emptyCourse(9),
      ...emptyCredits,
      compulsoryCreditsEarnedThisReport: '2', compulsoryCreditsEarnedToDate: '22',
      englishEarnedThisReport: '0', englishEarnedToDate: '3',
      scienceEarnedThisReport: '2', scienceEarnedToDate: '3',
      totalCreditsRequiredEarnedThisReport: '2', totalCreditsRequiredEarnedToDate: '22',
      specialistHighSkillsMajorName: 'Health Sciences',
      specialistHighSkillsMajorTotalRequired: '8',
      specialistHighSkillsMajorEarnedThisReport: '2',
      specialistHighSkillsMajorEarnedToDate: '6',
      oSSLiteracyRequirementCompleted: 'Completed - June 2024',
      _completedFields: [],
    },
  },
]
